import { memo } from "react";

import { LoadingPlaceholder } from "@vega-core/components/Loaders/LoadingPlaceholder";

type Props = {
  className?: string;
  roundedDefault?: boolean;
  roundedFull?: boolean;
  text?: string;
};

export const StyledPlaceholder = memo(
  ({ className, roundedDefault, roundedFull, text }: Props) => (
    <div className={className}>
      <LoadingPlaceholder
        roundedDefault={roundedDefault}
        roundedFull={roundedFull}
        text={text}
      />
    </div>
  ),
);
